<template>
  <app-layout></app-layout>
</template>

<script>
  import AppLayout from './components/app-layouts/layout'

  export default {
    components: {
      'app-layout': AppLayout
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// app.vue?0c541b05